import moment from "moment";
import store from "../Redux/store";
import { setSortName } from "../Redux/actions/user-actions";
import { authApi, getAuthorizationHeader } from "../api-calls/user-requests";

export const checkOnline = (id) => {
  const { teamMembersList } = store.getState()?.allUsers;

  if (teamMembersList && teamMembersList?.length > 0) {
    const teamMember = teamMembersList.find(
      (member) => member?.user_id?._id === id,
    );
    return teamMember?.status;
  }
  return null;
};

export const getNotificationUnseenCount = (notificationList) => {
  if (notificationList && notificationList?.length > 0) {
    return notificationList.filter((item) => item.is_seen === false)?.length;
  }
  return 0;
};

export const getChipColor = (name) => {
  const style = {
    backgrounndColor: "",
    color: "",
    padding: "",
    fontSize: "13px",
    textTransform: "capitalize",
  };
  if (name === "pending") {
    style.backgroundColor = "#F8F3E7";
    style.color = "#836824";
    style.padding = "13px 3px";
    return style;
  }
  if (name === "Present") {
    style.backgroundColor = "#E6F9F0";
    style.color = "#12A075";
    style.padding = "13px 3px";
    return style;
  }
  if (name === "Absent") {
    style.backgroundColor = "#FFE1E1";
    style.color = "#D72828";
    style.padding = "13px 3px";
    return style;
  }
  if (name === "completed") {
    style.backgroundColor = "#E6F9F0";
    style.color = "#1A6B44";
    style.padding = "13px 3px";
    return style;
  }
  if (name === "rejected") {
    style.backgroundColor = "#FEE1E1";
    style.color = "#9E0303";
    style.padding = "13px 3px";
    return style;
  }
  if (name === "REACHED_REQUIRES_CONFIRMATION") {
    style.backgroundColor = "#EAF0FB";
    style.color = "#2155A3";
    style.padding = "13px 3px";
    return style;
  }
  // Expense statuses — "submitted" is shown as "Pending".
  if (name === "submitted") {
    style.backgroundColor = "#FEF3C7";
    style.color = "#B45309";
    style.padding = "13px 3px";
    return style;
  }
  if (name === "approved") {
    style.backgroundColor = "#E6F9F0";
    style.color = "#1A6B44";
    style.padding = "13px 3px";
    return style;
  }
};

export const formatStatusLabel = (status) => {
  if (status === "REACHED_REQUIRES_CONFIRMATION") {
    return "Reached (Requires Confirmation)";
  }
  return status;
};

export const getTime = (date) => {
  const currentDate = new Date();
  const inputDate = new Date(date);
  const yesterday = new Date(currentDate);
  yesterday.setDate(currentDate.getDate() - 1);

  if (
    inputDate.getDate() === currentDate.getDate() &&
    inputDate.getMonth() === currentDate.getMonth() &&
    inputDate.getFullYear() === currentDate.getFullYear()
  ) {
    return "today";
  } else if (
    inputDate.getDate() === yesterday.getDate() &&
    inputDate.getMonth() === yesterday.getMonth() &&
    inputDate.getFullYear() === yesterday.getFullYear()
  ) {
    return "yesterday";
  } else {
    const newDate = moment(date).format("DD/MM/YYYY");
    return newDate;
  }
};

export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export const handleSortClick = (dispatch, sortBy, name) => {
  const namearr = name?.split("-");
  const sortByarr = sortBy?.split("-");
  if (sortByarr && sortByarr?.length > 0 && namearr[0] === sortByarr[0]) {
    if (sortByarr[1] === "asc") {
      dispatch(setSortName(`${namearr[0]}-desc`));
    } else {
      dispatch(setSortName(`${namearr[0]}-asc`));
    }
  } else {
    dispatch(setSortName(`${namearr[0]}-asc`));
  }
};

export const getTeamDetails = async (date, search) => {
  const fullDate = new Date(date);
  const formattedDate = fullDate.toISOString().split("T")[0];

  try {
    const queryParams = new URLSearchParams();

    if (search) {
      queryParams.append("team_name", search);
    }
    queryParams.append("date", formattedDate);

    const { data } = await authApi.get(
      `/teams/teamdetails?${queryParams.toString()}`,
      { headers: { Authorization: getAuthorizationHeader() } },
    );

    return data;
  } catch (error) {
    console.log(error);
  }
};
